import {
  ChartConfig,
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/chart";
import { useRef } from "react";
import { CartesianGrid, Line, LineChart, XAxis, YAxis } from "recharts";

type RollingSumChartData = {
  dateTime: string;
  revenue: number;
}[];

const chartConfig = {
  revenue: {
    label: "Rolling Revenue Sum €",
    color: "hsl(var(--chart-1))",
  },
} satisfies ChartConfig;

function RollingRevenueSumChart({ chartData }: { chartData: RollingSumChartData }) {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <ChartContainer config={chartConfig} ref={ref}>
      <LineChart data={chartData}>
        <CartesianGrid vertical={false} />
        <XAxis dataKey="dateTime" tickLine={false} axisLine={false} tickMargin={8} />
        <YAxis
          dataKey="revenue"
          tickLine={false}
          axisLine={false}
          tickMargin={8}
          tickFormatter={(value: number) => {
            return value.toLocaleString("en-US", {
              minimumFractionDigits: 0,
              currency: "EUR",
              style: "currency",
              compactDisplay: "short",
              notation: "compact",
            });
          }}
        />
        <ChartTooltip cursor={false} content={<ChartTooltipContent />} />
        <Line dataKey="revenue" type="linear" stroke="var(--color-revenue)" strokeWidth={2} dot={false} />

        <ChartLegend content={<ChartLegendContent />} />
      </LineChart>
    </ChartContainer>
  );
}

export default RollingRevenueSumChart;
